class AlternativeProductsLabelsDisplay {
	constructor(alternativeProductsBlock) {
		this.alternativeProductsBlock = alternativeProductsBlock;
	}

	hidePricePrefixes() {
		const alternativeProductsBlockPrices =
			this.alternativeProductsBlock.querySelectorAll('.product-price-panel');

		if (alternativeProductsBlockPrices) {
			alternativeProductsBlockPrices.forEach(price => {
				if (
					price.getAttribute('data-price-class') === 'PRICE_BREAK' ||
					price.getAttribute('data-price-class') === 'OFP'
				) {
					price
						.querySelector('.product-price-panel__price-prefix')
						.classList.add('product-price-panel__price-prefix--is-hidden');
				}
			});
		}
	}

	observeAlternativeProductsBlockMutations() {
		const observer = new MutationObserver(() => {
			this.hidePricePrefixes();
		});

		observer.observe(this.alternativeProductsBlock, {
			subtree: true,
			childList: true,
		});
	}

	init() {
		this.observeAlternativeProductsBlockMutations();
	}
}

export default AlternativeProductsLabelsDisplay;
